import { create } from "zustand";

interface DepositOnCexModalStore {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  handleOpen: () => void;
  handleClose: () => void;
}

export const useDepositOnCexModalStore = create<DepositOnCexModalStore>((set) => ({
  isOpen: false,
  setIsOpen: (open) => set({ isOpen: open }),
  handleOpen: () => set({ isOpen: true }),
  handleClose: () => set({ isOpen: false }),
}));
